"use client";

import {
  BottomSheet,
  BottomSheetContent,
  BottomSheetDescription,
  BottomSheetDragRegion,
  BottomSheetTitle,
} from "@/components/ui/bottom-sheet";
import { Button } from "@/components/ui/button";
import type { ListCtaLocation } from "@/lib/analytics/events";
import { useTranslations } from "next-intl";
import { ListYourEventGuide } from "./ListYourEventGuide";

interface ListYourEventBottomSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  location: ListCtaLocation;
}

const CONTENT_WIDTH = "mx-auto w-full sm:max-w-2xl";

export function ListYourEventBottomSheet({
  open,
  onOpenChange,
  location,
}: ListYourEventBottomSheetProps) {
  const t = useTranslations("listYourEvent");
  const tDialog = useTranslations("dialog");

  return (
    <BottomSheet open={open} onOpenChange={onOpenChange}>
      <BottomSheetContent
        open={open}
        onOpenChange={onOpenChange}
        className="max-h-[85vh]"
      >
        <BottomSheetDragRegion className="px-6">
          <div className={CONTENT_WIDTH}>
            <BottomSheetTitle className="text-left text-lg">
              {t("title")}
            </BottomSheetTitle>
            <BottomSheetDescription className="mt-1 text-left">
              {t("description")}
            </BottomSheetDescription>
          </div>
        </BottomSheetDragRegion>

        <div className="min-h-0 flex-1 overflow-y-auto px-6 pt-4">
          <div className={CONTENT_WIDTH}>
            <ListYourEventGuide location={location} />
          </div>
        </div>

        <div className="shrink-0 px-6 py-4">
          <div className={CONTENT_WIDTH}>
            <Button
              type="button"
              variant="outline"
              className="h-12 w-full rounded-full"
              onClick={() => onOpenChange(false)}
            >
              {tDialog("close")}
            </Button>
          </div>
        </div>
      </BottomSheetContent>
    </BottomSheet>
  );
}
